export const Thumbnail = {
    width: '38px',
    background: '#f3f4f7'
}